import { Scissors, Droplets, Wind, Sparkles, Heart, Shield } from "lucide-react";
import { IMG } from "@/lib/site";
import PageHero from "@/components/PageHero";
import SectionHeading from "@/components/SectionHeading";
import CtaSection from "@/components/CtaSection";

const servizi = [
  { icon: Droplets, t: "Lavaggio delicato", d: "Prodotti di qualità adatti al tipo di pelo." },
  { icon: Wind, t: "Asciugatura accurata", d: "A temperatura controllata, sempre in sicurezza." },
  { icon: Scissors, t: "Taglio e sistemazione", d: "Tagli personalizzati secondo razza e taglia." },
  { icon: Sparkles, t: "Cura del mantello", d: "Spazzolatura, districatura e trattamenti specifici." },
  { icon: Heart, t: "Igiene delle zone delicate", d: "Orecchie, occhi e unghie con attenzione." },
  { icon: Shield, t: "Trattamenti specifici", d: "Pelle sensibile, anti-prurito, mantelli particolari." },
];

export default function Toelettatura() {
  return (
    <div data-testid="page-toelettatura">
      <PageHero
        overline="Toelettatura professionale"
        title="Igiene, cura e benessere per il tuo cane"
        lead="Un servizio pensato per far sentire ogni animale a proprio agio: dolcezza, precisione e rispetto dei tempi del tuo cane."
        image={IMG.toelettatura}
        primaryCta={{ to: "/contatti", label: "Prenota ora" }}
        secondaryCta={{ to: "/pensione", label: "Scopri la pensione" }}
      />

      <section className="py-16 sm:py-24" data-testid="intro">
        <div className="max-w-5xl mx-auto px-6 sm:px-10 lg:px-12 text-center reveal">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#7A1F1F] mb-5">
            Un servizio curato e delicato
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl text-[#1A1710] leading-tight">
            La toelettatura non è solo estetica: <em className="italic text-[#7A1F1F]">è salute</em>.
          </h2>
          <p className="mt-6 text-lg text-[#6B5F4A] leading-relaxed">
            Un pelo curato è un cane sereno. Prevenzione, igiene e benessere
            sono al centro di ogni nostro intervento, sempre nel rispetto del
            carattere dell'animale.
          </p>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-[#EDD895]/60" data-testid="servizi-toelettatura">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12">
          <SectionHeading overline="Cosa offriamo" title="Un servizio completo, dall'inizio alla fine." />
          <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {servizi.map((s, i) => (
              <div
                key={s.t}
                className="reveal bg-[#F5E6C0] border border-[#D9C48A] rounded-3xl p-7"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="w-12 h-12 rounded-2xl bg-[#EDD895] grid place-items-center mb-5 text-[#8B4A2B]">
                  <s.icon className="w-6 h-6" strokeWidth={1.4} />
                </div>
                <h4 className="font-sans font-semibold text-[#1A1710] text-lg">{s.t}</h4>
                <p className="mt-2 text-sm text-[#6B5F4A] leading-relaxed">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24" data-testid="adatta-ogni-cane">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 reveal">
            <div className="aspect-[4/3] rounded-3xl overflow-hidden">
              <img src={IMG.toelettatura} alt="Toelettatura cani" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="lg:col-span-6 reveal">
            <SectionHeading
              overline="Adatta a ogni cane"
              title="Ogni cane è diverso, ogni trattamento è personalizzato."
              lead="Taglia, carattere, tipo di pelo, età e abitudini: tutto viene considerato per offrire un'esperienza piacevole e su misura."
            />
            <ul className="mt-7 space-y-3 text-[#6B5F4A]">
              {[
                "Cani di piccola, media e grande taglia",
                "Cuccioli al primo bagno e cani anziani",
                "Cani timidi: tempi più lunghi e tranquilli",
                "Mantelli corti, lunghi, ricci o doppi",
              ].map((p) => (
                <li key={p} className="flex gap-3">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#8B4A2B] flex-none" />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <CtaSection
        title="Prenota la toelettatura del tuo cane"
        lead="Chiamaci o scrivici per fissare un appuntamento. Saremo felici di accogliere il tuo amico."
        primaryLabel="Prenota ora"
      />
    </div>
  );
}
